






































































































































































import { Vue, Component, Prop } from "vue-property-decorator";
import _ from "@/boot/lodash";

// Enums/Data
import { DataModules } from "@/store/modules/data";

// Types
import { IAffiliatePendingCommission } from "@/models/affiliate";
import { IInvoice } from "@/models/invoices";
import { IClient } from "@/models/clients";

@Component({
  components: {
    "commission-summary": () =>
      import("@/components/app/global/affiliate/commissionSummary.vue"),
    "pending-commission-control": () =>
      import("@/components/app/global/affiliate/pendingCommissionControl.vue")
  }
})
export default class CalculatedCommissionsTable extends Vue {
  // Props

  @Prop({ required: true })
  public affiliateCommissions!: any[];

  @Prop({ required: true })
  public invoice!: IInvoice;

  @Prop({ default: 5 })
  public limit!: number;

  @Prop({ required: true })
  public isReloading!: boolean;

  @Prop({ default: undefined })
  public referrer?: IClient;

  // Variables

  public page = 1;
  public isProcessing = false;

  // Methods

  public onPageChange(value) {
    this.page = value;
  }

  public async runReassessment() {
    if (this.hasCommissions) {
      this.openRecalculateCommissionsModal();
      return;
    }

    try {
      this.isProcessing = true;
      await this.recalculateCommissions();
      this.$store.dispatch("toast/show", {
        message: this.$t("_.commissions_reassessed")
      });
      this.reloadData();
    } catch (error) {
      this.$store.dispatch("api/handleError", error);
    } finally {
      this.isProcessing = false;
    }
  }

  public openRecalculateCommissionsModal() {
    this.$store.dispatch(
      `data/${DataModules.AFFILIATES_COMMISSIONS}/openRecalculateCommissionsModal`,
      {
        props: {
          invoiceId: this.invoice?.id,
          currency: this.invoice?.currency
        },
        events: {
          success: this.reloadData
        }
      }
    );
  }

  public recalculateCommissions() {
    return this.$store.dispatch(
      `data/${DataModules.AFFILIATES_COMMISSIONS}/recalculateCommissions`,
      {
        invoiceId: this.invoice?.id,
        data: {
          override: 0,
          real_time: true
        }
      }
    );
  }

  public reloadData() {
    this.$emit("reload-data");
  }

  public async openApplyManualCommissionModal() {
    return this.$store.dispatch(
      `data/${DataModules.AFFILIATES_COMMISSIONS}/openApplyManualCommissionModal`,
      {
        props: {
          invoiceId: this.invoice.id,
          currency: this.invoice?.currency,
          hasUnpaidCommissions: this.hasUnpaidCommissions
        },
        events: {
          success: this.reloadData
        }
      }
    );
  }

  public isManualCommission(commission: IAffiliatePendingCommission) {
    return this.$_.isNull(commission.affiliate_tier_condition_id);
  }

  // Computed

  public get hasCommissions() {
    return !!this.affiliateCommissions.length;
  }

  public get affiliateCommissionsPage() {
    if (!this.hasCommissions) return Array(5);

    const start = (this.page > 1 ? this.page - 1 : 0) * this.limit;
    const end = this.page * this.limit;
    const affiliateCommissions = _.cloneDeep(this.affiliateCommissions);

    return start === end
      ? [affiliateCommissions[start]]
      : affiliateCommissions.slice(start, end);
  }

  public get hasReferrer() {
    return !_.isEmpty(this.referrer);
  }

  public get hasUnpaidCommissions() {
    return this.$_.some(this.affiliateCommissions, c => !c.rejected);
  }
}
